'use client'

import * as React from 'react'

import LogoSvg, {
  ApplicationActiveIcon,
  ApplicationDefaultIcon,
  ComplaintsActiveSVGIcon,
  ComplaintsDefaultSVGIcon,
  CustomersActiveIcon,
  CustomersDefaultIcon,
  DashboardActiveIcon,
  DashboardDefaultIcon,
  DeliveryActiveIcon,
  DeliveryDefaultIcon,
  HelpCenterActiveIcon,
  HelpCenterDefaultIcon,
  OrdersActiveIcon,
  OrdersDefaultIcon,
  PaymentsActiveIcon,
  PaymentsDefaultIcon,
  SettingsActiveIcon,
  SettingsDefaultIcon,
  UserManagementActiveIcon,
  UserManagementDefaultIcon,
  VendorsActiveIcon,
  VendorsDefaultIcon,
  WidthdrawalActiveIcon,
  WidthdrawalDefaultIcon,
} from '@/assets/svg'
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarHeader,
  SidebarRail,
} from '@/components/ui/sidebar'
import type { RootState } from '@/redux/features/root-reducer'
import { useAppSelector } from '@/redux/store'
import routesPath from '@/utils/routesPath'
import { NavProjects } from './nav-projects'
import { NavUser } from './nav-user'

const {
  DASHBOARD,
  ORDERS,
  VENDORS,
  CUSTOMERS,
  DELIVERY,
  WIDTHDRAWALS,
  COMMISSIONS,
  PAYMENTS,
  APPLICATIONS,
  USER_MANAGEMENT,
  COMPLAINTS,
  HELP_CENTER,
  SETTINGS,
  REFUNDS,
  CUSTOMER_TRANSACTIONS,
  VENDOR_TRANSACTIONS,
} = routesPath
// This is sample data.
const data = {
  user: {
    name: 'John Doe',
    email: 'john.doe@example.com',
    avatar: 'https://github.com/shadcn.png',
  },
  teams: [],
  projects: [
    {
      name: 'Dashboard',
      url: DASHBOARD,
      isActive: false,
      icon: {
        default: DashboardDefaultIcon,
        active: DashboardActiveIcon,
      },
    },
    {
      name: 'Orders',
      url: ORDERS,
      isActive: false,
      icon: {
        default: OrdersDefaultIcon,
        active: OrdersActiveIcon,
      },
    },
    {
      name: 'Vendors',
      url: VENDORS,
      isActive: false,
      icon: {
        default: VendorsDefaultIcon,
        active: VendorsActiveIcon,
      },
    },
    {
      name: 'Customers',
      url: CUSTOMERS,
      isActive: false,
      icon: {
        default: CustomersDefaultIcon,
        active: CustomersActiveIcon,
      },
    },
    {
      name: 'Delivery',
      url: DELIVERY,
      isActive: false,
      icon: {
        default: DeliveryDefaultIcon,
        active: DeliveryActiveIcon,
      },
    },
    {
      name: 'Payments',
      url: PAYMENTS,
      isActive: false,
      icon: {
        default: PaymentsDefaultIcon,
        active: PaymentsActiveIcon,
      },
    },
    {
      name: 'Transactions',
      url: '#',
      isActive: false,
      icon: {
        default: WidthdrawalDefaultIcon,
        active: WidthdrawalActiveIcon,
      },
      items: [
        {
          title: 'Withdrawal',
          url: WIDTHDRAWALS,
          isActive: false,
          default: WidthdrawalDefaultIcon,
          active: WidthdrawalActiveIcon,
        },
        {
          title: 'Customer Transactions',
          url: CUSTOMER_TRANSACTIONS,
          isActive: false,
          default: WidthdrawalDefaultIcon,
          active: WidthdrawalActiveIcon,
        },
        {
          title: 'Vendor Transactions',
          url: VENDOR_TRANSACTIONS,
          isActive: false,
          default: WidthdrawalDefaultIcon,
          active: WidthdrawalActiveIcon,
        },
        {
          title: 'Refunds',
          url: REFUNDS,
          isActive: false,
          default: WidthdrawalDefaultIcon,
          active: WidthdrawalActiveIcon,
        },
        {
          title: 'Commissions',
          url: COMMISSIONS,
          isActive: false,
          default: WidthdrawalDefaultIcon,
          active: WidthdrawalActiveIcon,
        },
      ],
    },
    {
      name: 'Applications',
      url: APPLICATIONS,
      isActive: false,
      icon: {
        default: ApplicationDefaultIcon,
        active: ApplicationActiveIcon,
      },
    },
    {
      name: 'User Management',
      url: USER_MANAGEMENT,
      isActive: false,
      icon: {
        default: UserManagementDefaultIcon,
        active: UserManagementActiveIcon,
      },
    },
    {
      name: 'Complaints',
      url: COMPLAINTS,
      isActive: false,
      icon: {
        default: ComplaintsDefaultSVGIcon,
        active: ComplaintsActiveSVGIcon,
      },
    },
    {
      name: 'Help Center',
      url: HELP_CENTER,
      isActive: false,
      icon: {
        default: HelpCenterDefaultIcon,
        active: HelpCenterActiveIcon,
      },
    },
    {
      name: 'Settings',
      url: SETTINGS,
      isActive: false,
      icon: {
        default: SettingsDefaultIcon,
        active: SettingsActiveIcon,
      },
    },
  ],
}

export function AppSidebar({ ...props }: React.ComponentProps<typeof Sidebar>) {
  // const { isMobile } = useSidebar()
  const { user } = useAppSelector((state: RootState) => state.auth)

  // if (!isMobile) {
  //   return <></>
  // }

  return (
    <Sidebar collapsible='icon' {...props}>
      <SidebarHeader>
        <div className='ml-2 mt-2'>
          <LogoSvg className='w-52' />
        </div>
      </SidebarHeader>
      <SidebarContent>
        {/* <NavMain items={data.navMain} /> */}
        <NavProjects projects={data.projects} />
      </SidebarContent>
      <SidebarFooter>
        <NavUser
          user={{
            name: user?.full_name || '',
            email: user?.email || '',
            avatar: user?.avatar_url || '',
          }}
        />
      </SidebarFooter>
      <SidebarRail />
    </Sidebar>
  )
}
